exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input_wrapper {\r\n  height: 50px;\r\n  border-radius: 4px;\r\n  border: solid 1px #e6e6e6;\r\n  background-color: white;\r\n  padding: 0 5px;\n}\r\n", ""]);

// exports
